import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { V1Subscription } from '@wix/ambassador-subscriptions-api/types';
import { Divider } from './Divider';
import SubscriptionsListItem from './SubscriptionsListItem';
import { st, classes } from './SubscriptionsList.st.css';

interface SubscriptionsListProps {
  subscriptions: V1Subscription[];
}

const SubscriptionsList = ({ subscriptions }: SubscriptionsListProps) => {
  const { isMobile } = useEnvironment();
  return (
    <>
      {!isMobile && <Divider />}
      <ul className={st(classes.root, isMobile ? { mobile: isMobile } : undefined)} data-hook="subscriptions-list">
        {subscriptions.map((subscription) => (
          <li key={subscription.id}>
            <SubscriptionsListItem subscription={subscription} />
            <Divider />
          </li>
        ))}
      </ul>
    </>
  );
};

export default SubscriptionsList;
